webpackJsonp([1],{

/***/ 1139:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1145:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1151:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1156:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1157:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1158:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1160:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 708,
	"./af.js": 708,
	"./ar": 715,
	"./ar-dz": 709,
	"./ar-dz.js": 709,
	"./ar-kw": 710,
	"./ar-kw.js": 710,
	"./ar-ly": 711,
	"./ar-ly.js": 711,
	"./ar-ma": 712,
	"./ar-ma.js": 712,
	"./ar-sa": 713,
	"./ar-sa.js": 713,
	"./ar-tn": 714,
	"./ar-tn.js": 714,
	"./ar.js": 715,
	"./az": 716,
	"./az.js": 716,
	"./be": 717,
	"./be.js": 717,
	"./bg": 718,
	"./bg.js": 718,
	"./bn": 719,
	"./bn.js": 719,
	"./bo": 720,
	"./bo.js": 720,
	"./br": 721,
	"./br.js": 721,
	"./bs": 722,
	"./bs.js": 722,
	"./ca": 723,
	"./ca.js": 723,
	"./cs": 724,
	"./cs.js": 724,
	"./cv": 725,
	"./cv.js": 725,
	"./cy": 726,
	"./cy.js": 726,
	"./da": 727,
	"./da.js": 727,
	"./de": 730,
	"./de-at": 728,
	"./de-at.js": 728,
	"./de-ch": 729,
	"./de-ch.js": 729,
	"./de.js": 730,
	"./dv": 731,
	"./dv.js": 731,
	"./el": 732,
	"./el.js": 732,
	"./en-au": 733,
	"./en-au.js": 733,
	"./en-ca": 734,
	"./en-ca.js": 734,
	"./en-gb": 735,
	"./en-gb.js": 735,
	"./en-ie": 736,
	"./en-ie.js": 736,
	"./en-nz": 737,
	"./en-nz.js": 737,
	"./eo": 738,
	"./eo.js": 738,
	"./es": 740,
	"./es-do": 739,
	"./es-do.js": 739,
	"./es.js": 740,
	"./et": 741,
	"./et.js": 741,
	"./eu": 742,
	"./eu.js": 742,
	"./fa": 743,
	"./fa.js": 743,
	"./fi": 744,
	"./fi.js": 744,
	"./fo": 745,
	"./fo.js": 745,
	"./fr": 748,
	"./fr-ca": 746,
	"./fr-ca.js": 746,
	"./fr-ch": 747,
	"./fr-ch.js": 747,
	"./fr.js": 748,
	"./fy": 749,
	"./fy.js": 749,
	"./gd": 750,
	"./gd.js": 750,
	"./gl": 751,
	"./gl.js": 751,
	"./gom-latn": 752,
	"./gom-latn.js": 752,
	"./he": 753,
	"./he.js": 753,
	"./hi": 754,
	"./hi.js": 754,
	"./hr": 755,
	"./hr.js": 755,
	"./hu": 756,
	"./hu.js": 756,
	"./hy-am": 757,
	"./hy-am.js": 757,
	"./id": 758,
	"./id.js": 758,
	"./is": 759,
	"./is.js": 759,
	"./it": 760,
	"./it.js": 760,
	"./ja": 761,
	"./ja.js": 761,
	"./jv": 762,
	"./jv.js": 762,
	"./ka": 763,
	"./ka.js": 763,
	"./kk": 764,
	"./kk.js": 764,
	"./km": 765,
	"./km.js": 765,
	"./kn": 766,
	"./kn.js": 766,
	"./ko": 767,
	"./ko.js": 767,
	"./ky": 768,
	"./ky.js": 768,
	"./lb": 769,
	"./lb.js": 769,
	"./lo": 770,
	"./lo.js": 770,
	"./lt": 771,
	"./lt.js": 771,
	"./lv": 772,
	"./lv.js": 772,
	"./me": 773,
	"./me.js": 773,
	"./mi": 774,
	"./mi.js": 774,
	"./mk": 775,
	"./mk.js": 775,
	"./ml": 776,
	"./ml.js": 776,
	"./mr": 777,
	"./mr.js": 777,
	"./ms": 779,
	"./ms-my": 778,
	"./ms-my.js": 778,
	"./ms.js": 779,
	"./my": 780,
	"./my.js": 780,
	"./nb": 781,
	"./nb.js": 781,
	"./ne": 782,
	"./ne.js": 782,
	"./nl": 784,
	"./nl-be": 783,
	"./nl-be.js": 783,
	"./nl.js": 784,
	"./nn": 785,
	"./nn.js": 785,
	"./pa-in": 786,
	"./pa-in.js": 786,
	"./pl": 787,
	"./pl.js": 787,
	"./pt": 789,
	"./pt-br": 788,
	"./pt-br.js": 788,
	"./pt.js": 789,
	"./ro": 790,
	"./ro.js": 790,
	"./ru": 791,
	"./ru.js": 791,
	"./sd": 792,
	"./sd.js": 792,
	"./se": 793,
	"./se.js": 793,
	"./si": 794,
	"./si.js": 794,
	"./sk": 795,
	"./sk.js": 795,
	"./sl": 796,
	"./sl.js": 796,
	"./sq": 797,
	"./sq.js": 797,
	"./sr": 799,
	"./sr-cyrl": 798,
	"./sr-cyrl.js": 798,
	"./sr.js": 799,
	"./ss": 800,
	"./ss.js": 800,
	"./sv": 801,
	"./sv.js": 801,
	"./sw": 802,
	"./sw.js": 802,
	"./ta": 803,
	"./ta.js": 803,
	"./te": 804,
	"./te.js": 804,
	"./tet": 805,
	"./tet.js": 805,
	"./th": 806,
	"./th.js": 806,
	"./tl-ph": 807,
	"./tl-ph.js": 807,
	"./tlh": 808,
	"./tlh.js": 808,
	"./tr": 809,
	"./tr.js": 809,
	"./tzl": 810,
	"./tzl.js": 810,
	"./tzm": 812,
	"./tzm-latn": 811,
	"./tzm-latn.js": 811,
	"./tzm.js": 812,
	"./uk": 813,
	"./uk.js": 813,
	"./ur": 814,
	"./ur.js": 814,
	"./uz": 816,
	"./uz-latn": 815,
	"./uz-latn.js": 815,
	"./uz.js": 816,
	"./vi": 817,
	"./vi.js": 817,
	"./x-pseudo": 818,
	"./x-pseudo.js": 818,
	"./yo": 819,
	"./yo.js": 819,
	"./zh-cn": 820,
	"./zh-cn.js": 820,
	"./zh-hk": 821,
	"./zh-hk.js": 821,
	"./zh-tw": 822,
	"./zh-tw.js": 822
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1322;

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1139)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1353),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1148)
__webpack_require__(1147)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1361),
  /* scopeId */
  "data-v-43320938",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1159)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1371),
  /* scopeId */
  "data-v-fbe12c26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1157)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(1368),
  /* scopeId */
  "data-v-ec14442e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1153)
__webpack_require__(1152)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1364),
  /* scopeId */
  "data-v-7dbc5436",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1156)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1367),
  /* scopeId */
  "data-v-ea1a22c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1151)
__webpack_require__(1150)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1363),
  /* scopeId */
  "data-v-6428b231",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1158)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1370),
  /* scopeId */
  "data-v-f83c886c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1143)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1357),
  /* scopeId */
  "data-v-1662144e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1160)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1372),
  /* scopeId */
  "data-v-ff413536",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1155)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1366),
  /* scopeId */
  "data-v-e4bdf2ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1141)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1355),
  /* scopeId */
  "data-v-1086e2e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1154)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1365),
  /* scopeId */
  "data-v-d33b6a7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(898),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1144)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1358),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1145)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1359),
  /* scopeId */
  "data-v-26b163be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1369),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1353:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('drawer', {
    attrs: {
      "show": _vm.showDrawer,
      "pos": "left",
      "tran": "push"
    },
    on: {
      "change-show": function($event) {
        _vm.showDrawer = arguments[0]
      }
    }
  }, [_c('div', {
    staticClass: "drawercontent",
    slot: "drawer"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', {
    staticClass: "modal-card-body titredrawerscroll"
  }, [_c('titre-drawer', {
    attrs: {
      "id": _vm.livreId
    }
  })], 1), _c('div', {
    staticClass: "modal-card-foot"
  }, [(_vm.livreEan13) ? _c('router-link', {
    staticClass: "is-primary button",
    attrs: {
      "to": {
        name: 'suggestion',
        params: {
          ean13: _vm.livreEan13
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDrawer($event)
      }
    }
  }, [_vm._v("Faire une recherche à partir de ce livre")]) : _vm._e()], 1)])]), _c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1354:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.titre) ? _c('book-default', {
    attrs: {
      "id": _vm.titre.livres && _vm.titre.livres[0].id
    },
    scopedSlots: _vm._u([
      ["default", function(ref) {
        var livre = ref.livre;

        return [_vm._t("default", null, {
          titre: _vm.titre,
          livre: livre
        })]
      }]
    ])
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1355:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-drawer pr4"
  }, [(_vm.livre) ? [_c('header', {
    staticClass: "header"
  }, [_c('cover-book', {
    staticClass: "cover",
    attrs: {
      "cover": _vm.livre && _vm.livre.couverture
    }
  }), _c('div', {
    staticClass: "infos"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.livre.titre))]), _c('h6', {
    staticClass: "subtitle auteurs"
  }, [_c('b', [_vm._v(_vm._s(_vm.auteurs))])])])], 1), _c('div', {
    staticClass: "desc content f5 lh-copy",
    domProps: {
      "innerHTML": _vm._s(_vm.livre.description)
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1356:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover-book",
    class: {
      'animated-background': !_vm.cover
    }
  }, [(_vm.cover) ? _c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.cover
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1357:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sign-out",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("deconnexion")])
},staticRenderFns: []}

/***/ }),

/***/ 1358:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-drawer"
  }, [_c('div', {
    staticClass: "main",
    style: ({
      'transform': 'translate3d(' + _vm.translateX + 'px,0,0)'
    })
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "mask",
    class: _vm.show ? 'active' : '',
    style: ({
      position: !_vm.show ? 'relative' : 'fixed'
    }),
    on: {
      "click": _vm.hideMask
    }
  })], 2), _vm._v(" "), _c('div', {
    ref: "drawer",
    staticClass: "drawer",
    class: [_vm.pos != 'left' ? 'drawer-right' : 'drawer-left', _vm.show ? 'active' : ''],
    style: ({
      position: !_vm.show ? 'relative' : 'fixed'
    })
  }, [_vm._t("drawer")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1359:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    attrs: {
      "tabindex": "1",
      "transition": "modal"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.closeModal($event)
      },
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "c vuelosebtn",
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default", [_vm._v("\n          default slot\n        ")])], 2)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mainsection hero is-fullheight is-dark"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container userinfowrapper"
  }, [_c('nav', {
    staticClass: "is-flex mt2"
  }, [_vm._m(0), _c('user-info', {
    staticClass: "userinfo",
    attrs: {
      "id": _vm.userId
    }
  })], 1)]), _c('div', {
    staticClass: "container flex-auto"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": {
        name: 'intro'
      },
      "exact": "exact"
    }
  }, [_vm._v("Chercher des suggestions")]), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": {
        name: 'new-ean13'
      },
      "exact": "exact"
    }
  }, [_vm._v("Ajouter un titre absent")])], 1)])]), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._t("default")], 2)]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-iem mr2",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "_margin-icon",
    attrs: {
      "src": __webpack_require__(829),
      "width": "80px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-foot"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', [_c('li', [_c('a', [_vm._v("Copyright 2017 Robert veut lire")])])])])])])
}]}

/***/ }),

/***/ 1361:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "accueil-scene"
  }, [_c('div', {
    staticClass: "wrapper columns"
  }, [_c('div', {
    staticClass: "column is-10 is-offset-1"
  }, [(!_vm.isBookSelected) ? [_c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.search),
      expression: "!search"
    }],
    staticClass: "bigtitle"
  }, [_vm._v("Robert veut lire")])]), _c('search-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isBookSelected),
      expression: "!isBookSelected"
    }],
    on: {
      "input": _vm.onLivreSelect,
      "search": function($event) {
        _vm.search = arguments[0]
      }
    }
  }), _c('hr'), (_vm.user) ? _c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "title is-3",
    domProps: {
      "innerHTML": _vm._s(_vm.user.contexte.titre)
    }
  }), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.user.contexte.description)
    }
  })]) : _vm._e()] : [(_vm.loadingSuggestion) ? _c('loading') : _c('div', {
    staticClass: "suggestionwrapper"
  }, [_c('div', {
    staticClass: "containerr tr"
  }, [_c('router-link', {
    staticClass: "button is-float-right",
    attrs: {
      "tag": "button",
      "to": {
        name: 'intro'
      }
    }
  }, [_vm._v("Faire une nouvelle recherche")]), (_vm.livre) ? _c('book-cover', {
    staticClass: "bookselected mb3 mt3",
    attrs: {
      "id": _vm.livre.id,
      "skin": "preview"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "suggestions"
  }, [_c('transition-group', {
    staticClass: "columns is-multiline",
    attrs: {
      "tag": "ul",
      "name": "bounce",
      "stagger": "200",
      "appear": "appear"
    }
  }, _vm._l((_vm.suggestedTitreIds), function(id, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-3-widescreen is-4-tablet is-6-mobile"
    }, [_c('div', {
      staticClass: "suggestionplaceholder"
    }, [(id) ? _c('book-rating', {
      staticClass: "bookrating",
      attrs: {
        "id": id,
        "contexte-id": _vm.contexteId
      },
      on: {
        "show-desc": _vm.showBookDesc
      }
    }) : _vm._e()], 1)])
  }))], 1)])]], 2)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1362:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-default skin",
    class: ("skin-" + _vm.skin)
  }, [_c('cover-book', {
    staticClass: "cover",
    attrs: {
      "cover": _vm.livre && _vm.livre.couverture
    }
  }), _c('div', {
    staticClass: "coverplace"
  }), (_vm.livre) ? [_c('div', {
    staticClass: "infos"
  }, [_c('h4', {
    staticClass: "titre b f5 mb2"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.livre.titre, 38)))]), _c('h6', {
    staticClass: "subtitl auteurs f6"
  }, [_c('b', [_vm._v(_vm._s(_vm.auteurs))])]), _c('div', {
    staticClass: "desc content",
    domProps: {
      "innerHTML": _vm._s(_vm.livre.description)
    }
  })]), _vm._t("default", null, {
    livre: _vm.livre
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1363:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input"
  }, [_c('multiselect', {
    staticClass: "multiselect",
    attrs: {
      "options": (!_vm.searchQuery || _vm.isISBN) ? [] : _vm.titres,
      "internal-search": false,
      "loading": _vm.isLoading,
      "allow-empty": true,
      "close-on-select": true,
      "id": "ajax",
      "label": "titre",
      "track-by": "id",
      "placeholder": "Rechercher un livre",
      "block-keys": ['Tab', 'Enter']
    },
    on: {
      "search-change": _vm.updateSearchQuery,
      "select": _vm.selectBook,
      "close": _vm.resetSearchQuery
    },
    scopedSlots: _vm._u([
      ["noResult", function(props) {
        return [(_vm.isISBN) ? _c('button', {
          staticClass: "button",
          attrs: {
            "type": "button"
          },
          on: {
            "mousedown": function($event) {
              $event.stopPropagation();
              _vm.selectISBN($event)
            }
          }
        }, [_vm._v("Chercher par ce ISBN")]) : (_vm.isLoading) ? _c('span', [_vm._v("Robert cherche...")]) : _c('span', [_vm._v("Livre introuvable")])]
      }],
      ["option", function(props) {
        return [_c('search-item-book', {
          staticClass: "searchitembook",
          class: {
            '-is-loading': _vm.isLoading
          },
          attrs: {
            "titre": props.option,
            "id": props.option.livres.length && props.option.livres[0].id
          }
        })]
      }]
    ])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1364:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-rating",
    class: {
      '-rated': _vm.hasBeenRated
    },
    on: {
      "mouseleave": _vm.resetEditState,
      "click": function($event) {
        _vm.$emit('show-desc', _vm.id)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "book-rating-panel"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBeenRated),
      expression: "hasBeenRated"
    }],
    staticClass: "panelmask",
    style: ({
      backgroundColor: _vm.rating ? 'rgba(255,176,45,.6)' : 'rgba(221,12,232,.6)'
    })
  }, [_c('span', {
    staticClass: "is-pre-line"
  }, [_vm._v(_vm._s(_vm.rating ? 'Robert \na raison' : 'Robert \ns\'est trompé'))])])]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    },
    on: {
      "after-leave": function($event) {
        _vm.$emit('animation-finish')
      }
    }
  }, [(!_vm.wantToRate) ? _c('div', {
    key: "1",
    staticClass: "inheritheight"
  }, [(_vm.id) ? _c('titre-default', {
    attrs: {
      "id": _vm.id
    },
    scopedSlots: _vm._u([
      ["default", function(ref) {
        var livre = ref.livre;

        return [_c('button', {
          staticClass: "evaluer button",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.wantsToRate(livre)
            }
          }
        }, [_vm._v("Évaluer")])]
      }]
    ])
  }) : _vm._e()], 1) : _c('div', {
    key: "2",
    staticClass: "inheritheight ratingbtns"
  }, [_c('button', {
    staticClass: "btnrating button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.rateBook(_vm.livre.ean13, true)
      }
    }
  }, [_vm._v("Robert "), _c('br'), _vm._v("a raison")]), _c('hr', {
    staticClass: "separator"
  }), _c('button', {
    staticClass: "btnrating button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.rateBook(_vm.livre.ean13, false)
      }
    }
  }, [_vm._v("Robert "), _c('br'), _vm._v("s'est trompé")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1365:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.titre) ? _c('book-drawer', {
    attrs: {
      "id": _vm.titre.livres && _vm.titre.livres[0].id
    },
    scopedSlots: _vm._u([
      ["default", function(ref) {
        var livre = ref.livre;

        return [_vm._t("default", null, {
          titre: _vm.titre,
          livre: livre
        })]
      }]
    ])
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1366:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-cover skin tl flex",
    class: ("skin-" + _vm.skin)
  }, [_c('cover-book', {
    staticClass: "cover w-25",
    attrs: {
      "cover": _vm.livre && _vm.livre.couverture
    }
  }), (_vm.livre) ? [_c('div', {
    staticClass: "infos flex-auto",
    staticStyle: {
      "width": "0"
    }
  }, [_c('h4', {
    staticClass: "titre b f4 mb1 gray"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.livre.titre, 38)))]), _c('h6', {
    staticClass: "subtitl auteurs f4 silver mb2"
  }, [_c('b', [_vm._v(_vm._s(_vm.auteurs))])]), _c('div', {
    staticClass: "desc content lh-copy f5",
    domProps: {
      "innerHTML": _vm._s(_vm.livre.description)
    }
  })]), _vm._t("default", null, {
    livre: _vm.livre
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1367:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input"
  }, [_vm._m(0), _c('h4', {
    staticClass: "subtitle is-3"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.tick <= 15) ? _c('span', {
    key: "1"
  }, [_vm._v("veut lire lance son algorithme.")]) : (_vm.tick <= 30) ? _c('span', {
    key: "2"
  }, [_vm._v("fouille dans ses bases de données.")]) : (_vm.tick <= 45) ? _c('span', {
    key: "3"
  }, [_vm._v("veut lire analyse le contexte du livre.")]) : (_vm.tick <= 60) ? _c('span', {
    key: "4"
  }, [_vm._v("compile les résultats.")]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title is-2"
  }, [_c('b', {
    staticClass: "white"
  }, [_vm._v("Robert")])])
}]}

/***/ }),

/***/ 1368:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "accueil-scene"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('form', {
    staticClass: "box",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchSuggestion($event)
      }
    }
  }, [_c('h1', {
    staticClass: "title is-3"
  }, [_vm._v("Ajouter un titre absent")]), _c('hr'), _c('label', {
    staticClass: "label"
  }, [_vm._v("ISBN")]), _c('p', {
    staticClass: "control"
  }, [_c('cleave', {
    staticClass: "input",
    attrs: {
      "options": _vm.cleavOpts,
      "type": "texte",
      "placeholder": "Entrer un numero isbn",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.hasSucceeded = false
      }
    },
    model: {
      value: (_vm.livreEan13),
      callback: function($$v) {
        _vm.livreEan13 = $$v
      },
      expression: "livreEan13"
    }
  })], 1), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSucceeded),
      expression: "hasSucceeded"
    }],
    staticClass: "control"
  }, [_c('span', [_vm._v("Ce titre a été rajouté. Il sera disponible sous peu.")])]), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.hasSucceeded
    }
  }, [_vm._v("Ajouter")])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1369:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1370:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverwrapper animated-background"
  }, [(_vm.livre) ? [(_vm.livre.couverture) ? _c('img', {
    attrs: {
      "src": _vm.livre.couverture
    }
  }) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "infos"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.titre.titre, 50)))]), _c('h6', {
    staticClass: "auteurs"
  }, [_vm._v(_vm._s(_vm.auteurs))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-scene"
  }, [_vm._m(0), _c('section', {
    staticClass: "mainsection hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('div', {
    staticClass: "box",
    class: {
      'is-shaking': _vm.hasError
    }
  }, [_c('form', {
    attrs: {
      "novalidate": "novalidate",
      "autocomplete": "on"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.requestAuth({
          email: _vm.email,
          password: _vm.password
        })
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Courriel")]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.hasError
    },
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "courriel@exemple.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('label', {
    staticClass: "label"
  }, [_vm._v("Mot de passe")]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.hasError
    },
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "●●●●●●●"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('hr'), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "subtitle is-6 is-danger"
  }, [_vm._v("Identifiants invalides.")]), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isLoading, 'is-danger': _vm.hasError
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(!_vm.hasError ? 'Connexion' : 'Réessayer'))])])])]), _c('p', {
    staticClass: "has-text-centered"
  })]), _vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "_margin-icon",
    attrs: {
      "src": __webpack_require__(829),
      "width": "90px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-11 is-offset-1"
  }, [_c('h1', {
    staticClass: "bigtitle title is-1"
  }, [_c('b', [_vm._v("Robert veut lire")])]), _c('h2', {
    staticClass: "subtitle is-3"
  }, [_vm._v("Client")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-5 is-offset-1"
  }, [_c('div', {
    staticClass: "content infos"
  }, [_c('p', [_vm._v("Pour obtenir les suggestions gratuites de Robert veut lire, vous devez avoir un compte.")]), _c('p', [_vm._v("Vous pouvez nous le demander en nous écrivant à "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "mailto:ici@robertveutlire.com"
    }
  }, [_vm._v("ici@robertveutlire.com")]), _vm._v(" ou simplement vous connecter avec l’identifiant suivant:")]), _c('table', {
    staticClass: "is-outline"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Courriel")])]), _c('td', [_vm._v("jeteste@robertveutlire.com")])]), _c('tr', [_c('td', [_c('b', [_vm._v("Mot de passe")])]), _c('td', [_vm._v("jaimerobert")])])])])])
}]}

/***/ }),

/***/ 1372:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-info"
  }, [(_vm.user) ? _c('h3', {
    staticClass: "b f3"
  }, [_vm._v(_vm._s(_vm.user.prenom) + " " + _vm._s(_vm.user.nom))]) : _vm._e(), _c('sign-out')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(836);
module.exports = __webpack_require__(835);


/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store2__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_store2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(141);










var EventBus = new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]();

var AuthService = void 0;
var expiration = void 0;
var axiosAuth = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create();
axiosAuth.interceptors.request.use(function (config) {
  var headers = AuthService.getAuthHeaders();
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config, {
    headers: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config.headers, headers ? { Authorization: headers } : {})
  });
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

var firstTimeFlag = true;
/* harmony default export */ __webpack_exports__["a"] = (AuthService = {
  signIn: function signIn(_ref) {
    var _this = this;

    var _ref$email = _ref.email,
        email = _ref$email === undefined ? '' : _ref$email,
        _ref$password = _ref.password,
        password = _ref$password === undefined ? '' : _ref$password;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var credentials, _ref2, data, token;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              credentials = { email: email, password: password };
              _context.prev = 1;
              _context.next = 4;
              return axiosAuth.post('/ia/contexte_usager/sign_in.json', { ia_contexte_usager: credentials });

            case 4:
              _ref2 = _context.sent;
              data = _ref2.data;
              token = data.token;

              AuthService.token = token;
              console.log('token', AuthService.token);

              return _context.abrupt('return', AuthService.checkAuth());

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](1);
              throw Error(_context.t0.message);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 12]]);
    }))();
  },
  signOut: function signOut() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return axiosAuth.delete('/ia/contexte_usager/sign_out.json');

            case 3:
              AuthService.token = null;
              _context2.next = 6;
              return AuthService.checkAuth();

            case 6:
              _context2.prev = 6;

              AuthService.emit('auth:disconnect');
              return _context2.finish(6);

            case 9:
              return _context2.abrupt('return', true);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0,, 6, 9]]);
    }))();
  },
  checkAuth: function checkAuth(force) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var token, shouldCheckToken, p$;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              token = AuthService.token;
              shouldCheckToken = AuthService.shouldCheckToken();

              force = firstTimeFlag || force;
              p$ = !shouldCheckToken && token && !force ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve({ token: AuthService.token }) : AuthService._validateToken(token);
              return _context3.abrupt('return', p$.then(function (_ref3) {
                var expirationDate = _ref3.date_expiration,
                    token = _ref3.token;

                expiration = expiration || expirationDate;
                return token;
              }, function (e) {
                AuthService.token = null;
                expiration = null;
                throw Error(e);
              }));

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  _validateToken: function _validateToken(token) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, expirationDate;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              firstTimeFlag = false;
              _context4.prev = 1;

              if (token) {
                _context4.next = 4;
                break;
              }

              throw Error('Token invalide');

            case 4:
              _context4.next = 6;
              return axiosAuth.get('/api/v2/ia/tokens.json', { params: { token: token } }).then(function (_ref4) {
                var data = _ref4.data;
                return data;
              });

            case 6:
              data = _context4.sent;
              expirationDate = data.date_expiration;

              if (expirationDate) {
                _context4.next = 10;
                break;
              }

              throw Error('Token expiré');

            case 10:
              AuthService.token = token;
              AuthService.emit('auth:success', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, { token: token }));
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, { token: token }));

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4['catch'](1);

              AuthService.emit('auth:fail', _context4.t0);
              throw Error(_context4.t0.message);

            case 19:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[1, 15]]);
    }))();
  },


  get token() {
    return AuthService.getToken();
  },
  set token(token) {
    if (token) {
      AuthService.persistToken(token);
    } else {
      AuthService.deleteToken();
    }
  },
  shouldCheckToken: function shouldCheckToken() {
    var token = AuthService.token;
    if (!token) return false;
    if (!expiration) return true;
    var nowMoment = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
    var expirationMoment = __WEBPACK_IMPORTED_MODULE_5_moment___default()(expiration * 1000, 'x');
    return nowMoment.isAfter(expirationMoment);
  },
  persistToken: function persistToken(token) {
    return __WEBPACK_IMPORTED_MODULE_6_store2___default.a.set('id_token', token);
  },
  deleteToken: function deleteToken() {
    return __WEBPACK_IMPORTED_MODULE_6_store2___default.a.remove('id_token');
  },
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_6_store2___default.a.get('id_token');
  },
  getAuthHeaders: function getAuthHeaders() {
    var token = AuthService.token;
    return token ? 'Bearer ' + token : undefined;
  },
  on: function on() {
    EventBus.$on.apply(EventBus, arguments);
  },
  off: function off() {
    EventBus.$off.apply(EventBus, arguments);
  },
  emit: function emit() {
    try {
      EventBus.$emit.apply(EventBus, arguments);
    } catch (e) {
      console.warn(e);
      throw Error(e.message);
    }
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__join_js__ = __webpack_require__(869);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__join_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__limit_js__ = __webpack_require__(870);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__limit_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__truncate_js__ = __webpack_require__(871);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__truncate_js__["a"]; });




/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1149)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1362),
  /* scopeId */
  "data-v-5011a4da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1140)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(1354),
  /* scopeId */
  "data-v-0e08f7c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isISBN;
function isISBN() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!string || typeof string !== 'string') return false;
  var pattern = /((?:[\dX]{13})|(?:[\d\-X]{17})|(?:[\dX]{10})|(?:[\d\-X]{13}))/gi;
  return !!string.match(pattern);
}

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_auth__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accueil_scene_vue__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accueil_scene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_accueil_scene_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_new_ean_scene_vue__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_new_ean_scene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_new_ean_scene_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_login_scene_vue__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_login_scene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_login_scene_vue__);



var _this = this;









__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: [{
    name: 'intro',
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_5__components_accueil_scene_vue___default.a
  }, {
    name: 'suggestion',
    path: '/suggestion/:ean13',
    component: __WEBPACK_IMPORTED_MODULE_5__components_accueil_scene_vue___default.a,
    props: function props(route) {
      return { ean13: route.params.ean13 };
    }
  }, {
    name: 'login',
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_7__components_login_scene_vue___default.a
  }, {
    name: 'new-ean13',
    path: '/new',
    component: __WEBPACK_IMPORTED_MODULE_6__components_new_ean_scene_vue___default.a
  }]
});

router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].checkAuth();

          case 3:
            next(to.name === 'login' ? { name: 'intro' } : true);
            _context.next = 9;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context['catch'](0);

            next(to.name !== 'login' ? { name: 'login', query: { redirect: to.path } } : true);

          case 9:
            _context.prev = 9;
            return _context.finish(9);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 6, 9, 11]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(141);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1146)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1360),
  /* scopeId */
  "data-v-325fbdeb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1142)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1356),
  /* scopeId */
  "data-v-114d23f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_axios__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setup_lodash__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setup_apollo__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_store__ = __webpack_require__(879);










__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */],
  apolloProvider: __WEBPACK_IMPORTED_MODULE_3__setup_apollo__["a" /* apolloProvider */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_5__App___default.a);
  }
});

/***/ }),

/***/ 869:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';

  return value.join(separator);
});

/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (value, limit) {
  return value.slice(0, limit);
});

/***/ }),

/***/ 871:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (value, trunc) {
  var ellipsis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

  if (!value || typeof value !== 'string') return;
  return value.length > trunc ? '' + value.slice(0, trunc) + ellipsis : value;
});

/***/ }),

/***/ 872:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeClass;
function addClass(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    el.className += ' ' + className;
  }
}
function removeClass(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
  }
}

/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apolloProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_client__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apollo__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(141);




var networkInterface = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_apollo_client__["a" /* createNetworkInterface */])({
  uri: '/api/queries',
  transportBatching: true
});

var apolloClient = new __WEBPACK_IMPORTED_MODULE_0_apollo_client__["b" /* default */]({
  networkInterface: networkInterface,
  dataIdFromObject: function dataIdFromObject(result) {
    if (result.id && result.__typename) {
      return result.__typename + result.id;
    }
    return null;
  }
});

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_1_vue_apollo___default.a({
  defaultClient: apolloClient
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_apollo___default.a);

/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_auth__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_index__ = __webpack_require__(587);





var _this = this;





__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (config) {
  var headers = __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].getAuthHeaders();
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config, {
    headers: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config.headers, headers ? { Authorization: headers } : {})
  });
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

var redirect401 = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(error) {
    var originalRequest, response, retry;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            originalRequest = error.config;
            response = error.response;

            if (!(response.status === 401)) {
              _context.next = 17;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].checkAuth(true);

          case 6:
            _context.next = 8;
            return __WEBPACK_IMPORTED_MODULE_4_axios___default()(originalRequest);

          case 8:
            retry = _context.sent;
            return _context.abrupt('return', retry);

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](3);


            __WEBPACK_IMPORTED_MODULE_6__router_index__["a" /* default */].push({ name: 'login', query: { redirect: __WEBPACK_IMPORTED_MODULE_6__router_index__["a" /* default */].currentRoute.path, forceRedirect: true } });

          case 15:
            _context.next = 18;
            break;

          case 17:
            throw new Error(error);

          case 18:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[3, 12]]);
  }));

  return function redirect401(_x) {
    return _ref.apply(this, arguments);
  };
}();
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.response.use(undefined, redirect401);

/***/ }),

/***/ 875:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es__ = __webpack_require__(228);




var mixins = {};
__WEBPACK_IMPORTED_MODULE_1_lodash_es__["c" /* default */].forEach(mixins, function (v, k) {
  __WEBPACK_IMPORTED_MODULE_1_lodash_es__["c" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, k, v));
});

/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_async_computed__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_async_computed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_async_computed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_system_bind_dispatcher_vue__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_system_bind_dispatcher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_system_bind_dispatcher_vue__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_async_computed___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('modal', __webpack_require__(1351));

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('bindDispatcher', __WEBPACK_IMPORTED_MODULE_3__components_shared_system_bind_dispatcher_vue___default.a);

var isDev = "production" !== 'production';
if (isDev) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = true;
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$img = function (img) {
  return '' + (isDev ? '/' : './') + img;
};

/***/ }),

/***/ 877:
/***/ (function(module, exports) {



/***/ }),

/***/ 878:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_dist_logger__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth_js__ = __webpack_require__(146);



var authPlugin = function authPlugin(store) {
  __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].on('auth:success', function (_ref) {
    var _ref$contexte_usager = _ref.contexte_usager,
        id = _ref$contexte_usager.id,
        context_id = _ref$contexte_usager.context_id;
    return store.commit('USER_REGISTER', { id: id, context_id: context_id });
  });
  __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].on('auth:fail', function () {
    return store.commit('USER_RESET');
  });
};
var plugins = [authPlugin];

/* harmony default export */ __webpack_exports__["a"] = ( false ? [createLogger()].concat(plugins) : plugins);

/***/ }),

/***/ 879:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions__);





var state = {
  userId: null,
  contexteId: null
};

var mutations = {
  USER_REGISTER: function USER_REGISTER(state, _ref) {
    var id = _ref.id,
        context_id = _ref.context_id;

    state.userId = id;
    state.contexteId = context_id;
  },
  USER_RESET: function USER_RESET(state) {
    state.userId = null;
    state.contexteId = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  mutations: mutations,
  plugins: __WEBPACK_IMPORTED_MODULE_1__plugins__["a" /* default */],
  getters: {
    userId: function userId(_ref2) {
      var _userId = _ref2.userId;
      return _userId;
    },
    contexteId: function contexteId(_ref3) {
      var _contexteId = _ref3.contexteId;
      return _contexteId;
    }
  }
}));

/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cleave_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    events: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      cleave: null
    };
  },


  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.cleave = new __WEBPACK_IMPORTED_MODULE_1_cleave_js___default.a(this.$el, this.options);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.events).map(function (key) {
      _this.$refs.input.addEventListener(key, _this.events[key]);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.cleave.destroy();
  },


  watch: {
    options: {
      deep: true,
      handler: function handler(val) {
        this.cleave.destroy();
        this.cleave = new __WEBPACK_IMPORTED_MODULE_1_cleave_js___default.a(this.$el, val);
      }
    }
  }

});

/***/ }),

/***/ 881:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_ui_drawer_vue__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_ui_drawer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_ui_drawer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_presentation_titre_drawer_vue__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_presentation_titre_drawer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_presentation_titre_drawer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_eventbus__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es__ = __webpack_require__(228);




var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['{\n          titre(id:"', '") {\n            id\n            livres {\n              ean13\n            }\n          }\n        }'], ['{\n          titre(id:"', '") {\n            id\n            livres {\n              ean13\n            }\n          }\n        }']);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    drawer: __WEBPACK_IMPORTED_MODULE_3__components_shared_ui_drawer_vue___default.a,
    titreDrawer: __WEBPACK_IMPORTED_MODULE_4__components_shared_presentation_titre_drawer_vue___default.a
  },
  data: function data() {
    return {
      showDrawer: false,
      livreId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5__services_eventbus__["a" /* default */].$on('book:show-desc', function (id) {
      _this.showDrawer = true;_this.livreId = id;
    });
  },

  asyncComputed: {
    livreEan13: function livreEan13() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, titre;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.livreId) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this2.$apollo.provider.defaultClient.query({
                  query: __WEBPACK_IMPORTED_MODULE_6_graphql_tag___default()(_templateObject, _this2.livreId)
                }).then(function (_ref2) {
                  var data = _ref2.data;
                  return data;
                });

              case 4:
                _ref = _context.sent;
                titre = _ref.titre;
                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es__["a" /* get */])(titre, 'livres[0].ean13'));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  methods: {
    closeDrawer: function closeDrawer() {
      this.showDrawer = false;
    }
  }
});

/***/ }),

/***/ 882:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_eventbus__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_presentation_book_default__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_presentation_book_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_presentation_book_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_presentation_book_cover__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_presentation_book_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_shared_presentation_book_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_presentation_titre_default__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_presentation_titre_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_shared_presentation_titre_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__search_search_input__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__search_search_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__search_search_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__search_book_rating__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__search_book_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__search_book_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shared_layouts_default_layout__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shared_layouts_default_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_shared_layouts_default_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__search_loading__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__search_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__search_loading__);





var _templateObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findBookBy($id: String) {\n    livre(id: $id) {\n      id\n      titre\n      sous_titre\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n'], ['\n  query findBookBy($id: String) {\n    livre(id: $id) {\n      id\n      titre\n      sous_titre\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findBookByEan($ean13: String) {\n    livres: search_livres_by(attrs: { ean13: $ean13 }) {\n      id\n      titre\n      sous_titre\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n'], ['\n  query findBookByEan($ean13: String) {\n    livres: search_livres_by(attrs: { ean13: $ean13 }) {\n      id\n      titre\n      sous_titre\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findUser($id: String) {\n    user: contexte_usager(id: $id) {\n      id\n      contexte {\n        description\n        titre\n      }\n    }\n  }\n'], ['\n  query findUser($id: String) {\n    user: contexte_usager(id: $id) {\n      id\n      contexte {\n        description\n        titre\n      }\n    }\n  }\n']);














var findBook = __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject);
var findBookByEan = __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject2);
var findUser = __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject3);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientScene',
  props: {
    ean13: {
      type: String
    }
  },
  data: function data() {
    return {
      suggestions: null,
      livre: null,
      livreId: null,
      livreEan13: null,
      search: null,
      user: null,
      loadingSuggestion: false
    };
  },

  components: {
    searchInput: __WEBPACK_IMPORTED_MODULE_11__search_search_input___default.a,
    titreDefault: __WEBPACK_IMPORTED_MODULE_10__components_shared_presentation_titre_default___default.a,
    bookDefault: __WEBPACK_IMPORTED_MODULE_8__components_shared_presentation_book_default___default.a,
    bookRating: __WEBPACK_IMPORTED_MODULE_12__search_book_rating___default.a,
    layout: __WEBPACK_IMPORTED_MODULE_13__components_shared_layouts_default_layout___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_14__search_loading___default.a,
    bookCover: __WEBPACK_IMPORTED_MODULE_9__components_shared_presentation_book_cover___default.a
  },
  methods: {
    findSuggestion: function findSuggestion(ean13) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, suggestions;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadingSuggestion = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/api/v2/ia/suggestions/' + ean13 + '.json').then(function (_ref2) {
                  var data = _ref2.data;
                  return data;
                });

              case 4:
                _ref = _context.sent;
                suggestions = _ref.suggestions;

                _this.suggestions = suggestions;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);
                throw _context.t0;

              case 12:
                _context.prev = 12;

                _this.loadingSuggestion = false;
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9, 12, 15]]);
      }))();
    },
    onLivreSelect: function onLivreSelect(_ref3) {
      var _ref3$id = _ref3.id,
          id = _ref3$id === undefined ? null : _ref3$id,
          ean13 = _ref3.ean13;

      this.livreId = id;
      this.$router.push({ name: 'suggestion', params: { ean13: ean13 } });
    },
    searchSuggestion: function searchSuggestion(ean13) {
      this.livreEan13 = ean13;
      this.findSuggestion(ean13);
    },
    resetSuggestion: function resetSuggestion() {
      this.livreEan13 = null;
      this.livreId = null;
      this.livre = null;
      this.loadingSuggestion = false;
      this.search = null;
      this.suggestions = null;
    },
    showBookDesc: function showBookDesc(id) {
      __WEBPACK_IMPORTED_MODULE_7__services_eventbus__["a" /* default */].$emit('book:show-desc', id);
    }
  },
  apollo: {
    livre: {
      query: function query() {
        return this.livreEan13 ? findBookByEan : findBook;
      },
      variables: function variables() {
        return { id: this.livreId, ean13: this.livreEan13 };
      },
      skip: function skip() {
        return !(this.livreId || this.livreEan13);
      },
      update: function update(data) {
        return this.livreEan13 ? data.livres[0] : data.livre;
      }
    },
    user: {
      query: findUser,
      variables: function variables() {
        return { id: this.userId };
      },
      skip: function skip() {
        return !this.userId;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['contexteId', 'userId']), {
    suggestedTitreIds: function suggestedTitreIds() {
      return this.suggestions ? this.suggestions.map(function (_ref4) {
        var id = _ref4.id;
        return id;
      }) : Array(8);
    },
    isBookSelected: function isBookSelected() {
      return this.livreId || this.livreEan13;
    }
  }),
  watch: {
    ean13: {
      immediate: true,
      handler: function handler(ean13) {
        if (ean13) this.searchSuggestion(ean13);else this.resetSuggestion();
      }
    }
  }
});

/***/ }),

/***/ 883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(146);




var signIn = __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].signIn;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoginScene',
  props: {},
  data: function data() {
    return {
      email: null,
      password: null,
      isLoading: false,
      hasError: false
    };
  },

  methods: {
    requestAuth: function requestAuth() {
      var _this = this;

      this.isLoading = true;
      signIn({ email: this.email, password: this.password }).then(function () {
        var redirect = decodeURIComponent(_this.$route.query.redirect);
        var validRedirection = _this.$router.resolve({ path: redirect }).route.matched.length;
        _this.$router.push(redirect && validRedirection ? { path: redirect } : { name: 'intro' });
      }, function (e) {
        console.log(e);
        _this.hasError = true;
      }).then(function () {
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ 884:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_layouts_default_layout_vue__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_layouts_default_layout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_layouts_default_layout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cleave__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_isbn_js__ = __webpack_require__(586);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewScene',
  props: {},
  data: function data() {
    return {
      isLoading: false,
      livreEan13: null,
      hasSucceeded: false,
      cleavOpts: {
        numericOnly: true,
        blocks: [13]
      }
    };
  },

  components: {
    cleave: __WEBPACK_IMPORTED_MODULE_4_vue_cleave___default.a,
    layout: __WEBPACK_IMPORTED_MODULE_3__components_shared_layouts_default_layout_vue___default.a
  },
  methods: {
    findSuggestion: function findSuggestion(ean13) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_isbn_js__["a" /* isISBN */])(ean13)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.isLoading = true;
                _this.hasSucceeded = false;
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/v2/ia/suggestions/' + ean13);

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](4);
                throw _context.t0;

              case 12:
                _context.prev = 12;

                _this.isLoading = false;
                _this.hasSucceeded = true;
                return _context.finish(12);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 9, 12, 16]]);
      }))();
    },
    searchSuggestion: function searchSuggestion() {
      this.findSuggestion(this.livreEan13);
    }
  }

});

/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_presentation_titre_default_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_presentation_titre_default_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_presentation_titre_default_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BookRating',
  props: {
    id: {
      type: String
    },
    contexteId: {
      required: true
    }
  },
  data: function data() {
    return {
      hasBeenRated: false,
      rating: 'Robert s\'est trompé',
      wantToRate: false,
      livre: false
    };
  },

  components: {
    titreDefault: __WEBPACK_IMPORTED_MODULE_3__components_shared_presentation_titre_default_vue___default.a
  },
  methods: {
    rateBook: function rateBook(ean13) {
      var _this = this;

      var rating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.hasBeenRated === true)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.$once('animation-finish', function () {
                  _this.$nextTick(function () {
                    _this.hasBeenRated = true;
                  });
                });
                _this.wantToRate = false;
                _this.rating = rating;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/v2/ia/suggestions/' + ean13 + '/evaluer', undefined, { params: { liaison: rating } });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    resetEditState: function resetEditState() {
      var _this2 = this;

      setTimeout(function () {
        _this2.wantToRate = false;
      }, 1000);
    },
    wantsToRate: function wantsToRate(livre) {
      this.wantToRate = true;
      this.livre = livre;
    }
  }
});

/***/ }),

/***/ 886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  data: function data() {
    return {
      tick: 0
    };
  },

  computed: {
    phrase: function phrase() {
      return this.tick % 4;
    }
  },
  mounted: function mounted() {
    this.changeLetter();
  },

  methods: {
    changeLetter: function changeLetter() {
      var _this = this;

      setTimeout(function () {
        _this.tick++;
        _this.changeLetter();
      }, 250);
    }
  }
});

/***/ }),

/***/ 887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_isbn__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_item_book_vue__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_item_book_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__search_item_book_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findTitresByTitle($title: String!, $limit: Int, $page: Int) {\n    # titres: titres(attrs: {titre: $title}, limit: $limit, page: $page) {\n    titres: search_titres(q: $title, limit: $limit, page: $page) {\n      id\n      titre\n      livres {\n        id\n        ean13\n      }\n    }\n  }\n'], ['\n  query findTitresByTitle($title: String!, $limit: Int, $page: Int) {\n    # titres: titres(attrs: {titre: $title}, limit: $limit, page: $page) {\n    titres: search_titres(q: $title, limit: $limit, page: $page) {\n      id\n      titre\n      livres {\n        id\n        ean13\n      }\n    }\n  }\n']);





var findTitresByTitle = __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'naturalSearch',
  props: {
    value: {},
    search: {}
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
    searchItemBook: __WEBPACK_IMPORTED_MODULE_5__search_item_book_vue___default.a
  },
  data: function data() {
    return {
      titres: [],
      loadingTitres: 0,
      searchQuery: ''
    };
  },

  apollo: {
    titres: {
      query: findTitresByTitle,
      loadingKey: 'loadingTitres',
      variables: function variables() {
        return {
          title: this.searchQuery,
          limit: 10,
          page: 1
        };
      },
      error: function error() {},
      skip: function skip() {
        return !(this.searchQuery || this.isISBN);
      },
      result: function result(titres) {
        console.log(titres);
      }
    }
  },
  computed: {
    isLoading: function isLoading() {
      return !!this.loadingTitres;
    },
    isISBN: function isISBN() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_isbn__["a" /* isISBN */])(this.searchQuery);
    }
  },
  methods: {
    resetSearchQuery: function resetSearchQuery() {
      this.searchQuery = null;this.titres = [];
    },
    selectBook: function selectBook(_ref) {
      var livres = _ref.livres;

      var livre = livres.length && livres[0];
      this.$emit('input', livre);
    },
    selectISBN: function selectISBN() {
      this.$emit('input', { ean13: this.searchQuery });
    },

    updateSearchQuery: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es__["b" /* throttle */])(function updateSearchQuery(searchQuery) {
      this.searchQuery = searchQuery;
      this.$emit('search', searchQuery);
    }, 600, { trailing: true }) }
});

/***/ }),

/***/ 888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters__ = __webpack_require__(259);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findBook($id: String) {\n    livre(id: $id) {\n      id\n      titre\n      sous_titre\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n'], ['\n  query findBook($id: String) {\n    livre(id: $id) {\n      id\n      titre\n      sous_titre\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n']);





var findBook = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchBookItem',
  props: {
    titre: {},
    id: {
      type: String
    }
  },
  filters: {
    limit: __WEBPACK_IMPORTED_MODULE_2__filters__["a" /* limit */],
    join: __WEBPACK_IMPORTED_MODULE_2__filters__["b" /* join */],
    truncate: __WEBPACK_IMPORTED_MODULE_2__filters__["c" /* truncate */]
  },
  data: function data() {
    return {
      livre: null,
      loadingTitres: 0,
      searchQuery: ''
    };
  },

  apollo: {
    livre: {
      query: findBook,
      loadingKey: 'loadingTitres',
      variables: function variables() {
        return {
          id: this.id
        };
      },
      skip: function skip() {
        return !this.id;
      }
    }
  },
  computed: {
    isLoading: function isLoading() {
      return !!this.loadingTitres;
    },
    auteurs: function auteurs() {
      return this.livre && this.livre.auteurs.map(function (_ref) {
        var nom = _ref.nom;
        return nom;
      }).slice(0, 2).join(', ');
    }
  },
  methods: {}
});

/***/ }),

/***/ 889:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_user_info_vue__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_user_info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__login_user_info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(250);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DefaultLayout',
  components: {
    userInfo: __WEBPACK_IMPORTED_MODULE_1__login_user_info_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['userId']))
});

/***/ }),

/***/ 890:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(146);





var _signOut = __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].signOut;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SignOut',
  data: function data() {
    return {};
  },

  methods: {
    signOut: function signOut() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _signOut();

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 8:
                _context.prev = 8;

                _this.$router.push({ name: 'login' });
                return _context.finish(8);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 5, 8, 11]]);
      }))();
    }
  }
});

/***/ }),

/***/ 891:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sign_out_vue__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sign_out_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sign_out_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findUser($id: String) {\n    user: contexte_usager(id: $id) {\n      id\n      # email\n      nom\n      prenom\n    }\n  }\n'], ['\n  query findUser($id: String) {\n    user: contexte_usager(id: $id) {\n      id\n      # email\n      nom\n      prenom\n    }\n  }\n']);



var findUser = __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserInfo',
  props: {
    id: {}
  },
  data: function data() {
    return {
      user: null
    };
  },

  components: {
    signOut: __WEBPACK_IMPORTED_MODULE_1__sign_out_vue___default.a
  },
  apollo: {
    user: {
      query: findUser,
      variables: function variables() {
        return {
          id: this.id
        };
      },
      skip: function skip() {
        return !this.id;
      }
    }
  }
});

/***/ }),

/***/ 892:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cover_book_vue__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cover_book_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cover_book_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findBook($id: String) {\n    livre(id: $id) {\n      id\n      titre\n      ean13\n      sous_titre\n      description\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n'], ['\n  query findBook($id: String) {\n    livre(id: $id) {\n      id\n      titre\n      ean13\n      sous_titre\n      description\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n']);





var findBook = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Book',
  props: {
    id: {},
    skin: {
      default: 'default'
    }
  },
  data: function data() {
    return {
      livre: null
    };
  },

  apollo: {
    livre: {
      query: findBook,
      variables: function variables() {
        return {
          id: this.id
        };
      },
      skip: function skip() {
        return !this.id;
      }
    }
  },
  filters: {
    limit: __WEBPACK_IMPORTED_MODULE_2__filters__["a" /* limit */],
    join: __WEBPACK_IMPORTED_MODULE_2__filters__["b" /* join */],
    truncate: __WEBPACK_IMPORTED_MODULE_2__filters__["c" /* truncate */]
  },
  components: {
    coverBook: __WEBPACK_IMPORTED_MODULE_3__cover_book_vue___default.a
  },
  computed: {
    auteurs: function auteurs() {
      return this.livre && this.livre.auteurs.map(function (_ref) {
        var nom = _ref.nom;
        return nom;
      }).slice(0, 2).join(', ');
    }
  }
});

/***/ }),

/***/ 893:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cover_book_vue__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cover_book_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cover_book_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findBook($id: String) {\n    livre(id: $id) {\n      id\n      titre\n      ean13\n      sous_titre\n      description\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n'], ['\n  query findBook($id: String) {\n    livre(id: $id) {\n      id\n      titre\n      ean13\n      sous_titre\n      description\n      couverture: couverture_url\n      auteurs {\n        nom\n      }\n    }\n  }\n']);





var findBook = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Book',
  props: {
    id: {},
    skin: {
      default: 'default'
    }
  },
  data: function data() {
    return {
      livre: null
    };
  },

  apollo: {
    livre: {
      query: findBook,
      variables: function variables() {
        return {
          id: this.id
        };
      },
      skip: function skip() {
        return !this.id;
      }
    }
  },
  filters: {
    limit: __WEBPACK_IMPORTED_MODULE_2__filters__["a" /* limit */],
    join: __WEBPACK_IMPORTED_MODULE_2__filters__["b" /* join */],
    truncate: __WEBPACK_IMPORTED_MODULE_2__filters__["c" /* truncate */]
  },
  components: {
    coverBook: __WEBPACK_IMPORTED_MODULE_3__cover_book_vue___default.a
  },
  computed: {
    auteurs: function auteurs() {
      return this.livre && this.livre.auteurs.map(function (_ref) {
        var nom = _ref.nom;
        return nom;
      }).slice(0, 2).join(', ');
    }
  }
});

/***/ }),

/***/ 894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__book_default_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__book_default_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__book_default_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__book_default_vue___default.a
});

/***/ }),

/***/ 895:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cover',
  props: {
    cover: {
      required: true
    }
  }
});

/***/ }),

/***/ 896:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__book_default_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__book_default_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__book_default_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query findTitre($id: String) {\n    titre(id: $id) {\n      id\n      titre\n      livres {\n        id\n      }\n    }\n  }\n'], ['\n  query findTitre($id: String) {\n    titre(id: $id) {\n      id\n      titre\n      livres {\n        id\n      }\n    }\n  }\n']);




var findTitre = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Titre',
  props: {
    id: {}
  },
  data: function data() {
    return {
      titre: null
    };
  },

  components: {
    bookDefault: __WEBPACK_IMPORTED_MODULE_2__book_default_vue___default.a
  },
  apollo: {
    titre: {
      query: findTitre,
      variables: function variables() {
        return {
          id: this.id
        };
      },
      skip: function skip() {
        return !this.id;
      }
    }
  },
  computed: {}
});

/***/ }),

/***/ 897:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__titre_default_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__titre_default_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__titre_default_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__book_drawer_vue__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__book_drawer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__book_drawer_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Titre',
  extends: __WEBPACK_IMPORTED_MODULE_0__titre_default_vue___default.a,
  components: {
    bookDrawer: __WEBPACK_IMPORTED_MODULE_1__book_drawer_vue___default.a
  }
});

/***/ }),

/***/ 898:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es__ = __webpack_require__(228);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'binding', 'components'],
  created: function created() {
    var props = [];
    if (this.binding) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es__["d" /* forOwn */])(this.binding, function (value, key) {
        props.push(':' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es__["e" /* kebabCase */])(key) + '="binding[\'' + key + '\']"');
      });
    }
    this.$options.components = this.components;
    this.$options.template = '<component :is="name" ' + props.join(' ') + '>\n\n    </component>';
  }
});

/***/ }),

/***/ 899:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pos: {
      type: String,
      default: 'left'
    },
    tran: {
      type: String,
      default: 'overlay'
    }
  },
  data: function data() {
    return {
      drawerWidth: 0,
      translateX: 0
    };
  },

  watch: {
    show: function show() {
      if (!this.show) {
        this.$emit('on-hide');
      } else {
        this.$emit('on-show');
      }

      if (this.tran === 'overlay') return;
      if (!this.show) {
        this.translateX = 0;
      } else {
        this.translateX = this.pos === 'left' ? this.drawerWidth : -this.drawerWidth;
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.drawerWidth = this.$refs.drawer.clientWidth;
    });
  },

  methods: {
    hideMask: function hideMask() {
      this.$emit('change-show', false);
    }
  }
});

/***/ }),

/***/ 900:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_dom__ = __webpack_require__(872);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  watch: {
    'show': function show() {
      if (!this.show) return;
      this.$nextTick(function () {
        var els = document.querySelectorAll('.wrapper-hype');
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(els).forEach(function (el) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_dom__["a" /* addClass */])(el, '-noscroll');
        });
        this.$el.focus();
      });
    }
  },
  methods: {
    closeModal: function closeModal() {
      var els = document.querySelectorAll('.wrapper-hype');
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(els).forEach(function (el) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_dom__["b" /* removeClass */])(el, '-noscroll');
      });
      this.show = false;
      this.$emit('hide');
    }
  }
});

/***/ })

},[1377]);


// WEBPACK FOOTER //
// static/js/app.8f5ec517356ab566e723.js